export default {
    computed: {
        tabs() {
            var uri = this.$access.aliasToUri(this.$route.name),
                views = this.$store.state.resource.scopedViews[uri] || {}

            return Object.keys(views).reduce((acc, uri) => {
                var v = views[uri]

                // 过滤，隐藏的tab不显示
                if (v.meta.hideInMenu === false) {
                    acc[uri] = v
                }

                return acc
            }, {})
        },
    },
    watch: {
        active(val) {
            this.$cache.active = val
        },
    },
    created() {
        this.initTab()
    },
    methods: {
        // 初始化tab
        initTab() {
            var firstTab = Object.values(this.tabs)[0]

            // 优先取query
            var targetTab = this.$route.query.active

            if (targetTab) {
                return (this.active = targetTab)
            }

            // 缺省选中第一个
            if (firstTab && !this.active) {
                this.active = firstTab.name
            }
        },
    },
}
